import createSelector from "../../utils/reselect";

const purchaseOrdersStateData = (state) => {
  const { purchaseOrders } = state;
  return purchaseOrders || {};
};

export const getError = createSelector(
  purchaseOrdersStateData,
  (purchaseOrders) => purchaseOrders.get("error")
);

export const purchaseOrdersPagination = createSelector(
  purchaseOrdersStateData,
  (purchaseOrders) => purchaseOrders.get("purchaseOrdersPagination")
);

export const purchaseOrders = createSelector(
  purchaseOrdersStateData,
  (purchaseOrders) => purchaseOrders.get("purchaseOrders")
);

export const purchaseOrdersLoading = createSelector(
  purchaseOrdersStateData,
  (purchaseOrders) => purchaseOrders.get("pageLoading")
);

export const purchaseOrderLoading = createSelector(
  purchaseOrdersStateData,
  (purchaseOrders) => purchaseOrders.get("purchaseOrderLoading")
);
